(function () {
    // wedev change (a11y): colours that are out of stock now carry aria-disabled instead of the
    // disabled attribute, so that keyboard and screen-reader users can still reach them. They must
    // never become the card's selection, which is what the guards below are for.
    function isUnavailable(input) {
        return input.disabled || input.getAttribute('aria-disabled') === 'true';
    }

    const lastCheckedChoice = new WeakMap();

    function rememberCheckedChoice(target) {
        const group = target?.closest?.('.wd-card-product-colors');
        if (!group) return;

        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked) lastCheckedChoice.set(group, checked);
    }

    function updateProductCardFromColorInput(input) {
        const colors = input.closest('.wd-card-product-colors');
        if (!colors) return;

        const imageUrl = input.getAttribute('data-image');
        if (!imageUrl) return;

        const card = colors.closest('.apl-section-product-card');
        const img = card?.querySelector('img.apl-section-product-card-image');
        if (img) {
            img.removeAttribute('srcset');
            const url = new URL(imageUrl, document.baseURI);
            url.searchParams.set('width', '300');
            img.src = url.toString();
        }

        const label = input.nextElementSibling;
        const href =
            label && label.tagName === 'LABEL'
                ? label.getAttribute('data-pdp-url')
                : null;
        if (!href || !card) return;

        const links = card.parentElement.querySelectorAll(
            '.button-cart a, .apl-section-product-title > a, .apl-section-product-card > a'
        );
        links.forEach((link) => {
            link.href = href;
        });
    }

    document.addEventListener('mouseover', (e) => {
        const target = e.target;
        const colorContainer = target?.classList?.contains('wd-card-product-colors')
            ? target
            : target?.closest('.wd-card-product-colors');
        if (!colorContainer) return;

        const allColors = colorContainer.querySelectorAll('input[type="radio"]');
        const allImages = [];
        allColors.forEach((color) => {
            allImages.push(color.getAttribute('data-image'));
        });

        allImages.forEach((imageUrl) => {
            if (!imageUrl) return;
            const url = new URL(imageUrl, document.baseURI);
            url.searchParams.set('width', '300');
            const img = new Image();
            img.src = url.toString();
        });
    }, { passive: true });

    // Snapshot the current choice before the browser acts on the key or the click, so an
    // out-of-stock colour can be put back where it was.
    ['keydown', 'pointerdown'].forEach((type) => {
        document.addEventListener(type, (e) => rememberCheckedChoice(e.target), true);
    });

    document.addEventListener('change', (e) => {
        const input = e.target;
        if (!input.matches?.('.wd-card-product-colors input[type="radio"]')) return;

        if (isUnavailable(input)) {
            // Arrow keys check a radio as they move through the group. Undo that: the colour is
            // announced and focused, but the card keeps the choice it had.
            const previous = lastCheckedChoice.get(input.closest('.wd-card-product-colors'));

            if (previous && previous !== input) previous.checked = true;
            else if (!previous) input.checked = false;

            return;
        }

        lastCheckedChoice.set(input.closest('.wd-card-product-colors'), input);
        updateProductCardFromColorInput(input);
    });

    document.addEventListener('focusin', (e) => {
        const input = e.target;
        if (!input.matches?.('.wd-card-product-colors input[type="radio"]')) return;
        if (isUnavailable(input)) return;
        if (!input.checked) {
            input.checked = true;
            lastCheckedChoice.set(input.closest('.wd-card-product-colors'), input);
            updateProductCardFromColorInput(input);
        }
    });
})();
